export { default as QuickBookingArticleD } from './QuickBookingArticleD'
export { default as QuickBookingArticleDSkeleton } from './Skeleton'
